export const grid = {
  columnCount: 12,
  gap: {
    min: 12,
    max: 24,
  },
}
